import React from 'react';
import paths from './paths';

function Icon({ name, strokeWidth = 2, size, ...rest }) {
  return (
    <svg
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth={strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden="true"
      {...(size ? { width: size, height: size } : {})}
      {...rest}
    >
      {paths[name]}
    </svg>
  );
}

export default Icon;
